import React, { useState, useEffect } from 'react';
import { 
  FaWhatsapp, 
  FaEnvelope, 
  FaPhone, 
  FaMapMarkerAlt, 
  FaClock, 
  FaFacebook, 
  FaInstagram, 
  FaTwitter, 
  FaYoutube,
  FaPaperPlane,
  FaCheckCircle,
  FaTimes,
  FaUser,
  FaComment,
  FaFish,
  FaHome,
  FaHeart,
  FaUserCircle
} from 'react-icons/fa';
import { MdLocationOn, MdEmail, MdPhone, MdAccessTime, MdSend } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

const ContactPage = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [formStatus, setFormStatus] = useState({
    submitted: false,
    success: false,
    message: ''
  });
  const [activeTab, setActiveTab] = useState('contact');
  const [activeField, setActiveField] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Simulate form submission
    setFormStatus({
      submitted: true,
      success: true,
      message: 'Thank you for your message! We will get back to you within 24 hours.'
    });
    
    // Reset form after 3 seconds
    setTimeout(() => {
      setFormStatus({
        submitted: false,
        success: false,
        message: ''
      });
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
    }, 3000);
  };

  const handleWhatsAppClick = () => {
    const message = `Hi Lion Head Team, I would like to get more information about your premium fish food.`;
    window.open(`https://wa.me/918072621187?text=${encodeURIComponent(message)}`, '_blank');
  };

  const contactInfo = [
    {
      icon: <FaPhone className="text-xl" />,
      title: 'Phone Number',
      details: ['+91 80726 21187', '+91 80726 21187'],
      action: 'Call Now',
      onClick: () => window.location.href = 'tel:+918072621187'
    },
    {
      icon: <FaWhatsapp className="text-xl" />,
      title: 'WhatsApp',
      details: ['+91 80726 21187'],
      action: 'Message Us',
      onClick: handleWhatsAppClick
    },
    {
      icon: <FaEnvelope className="text-xl" />,
      title: 'Email Address',
      details: ['support@lionhead.in', 'sales@lionhead.in'],
      action: 'Send Email',
      onClick: () => window.location.href = 'mailto:support@lionhead.in'
    },
    {
      icon: <FaMapMarkerAlt className="text-xl" />,
      title: 'Office Address',
      details: ['126.Rice.mill.sengulam.po.moonttaippu.via.Tirunelveli-627152'],
    //   action: 'Get Directions',
      onClick: () => window.open('https://maps.google.com/?q=Tirunelveli', '_blank')
    }
  ];

  const businessHours = [
    { day: 'Monday - Saturday', hours: '9:00 AM - 7:00 PM' },
    // { day: 'Saturday', hours: '10:00 AM - 5:00 PM' },
    { day: 'Sunday', hours: 'Closed' }
  ];

  const socialLinks = [
    { icon: <FaFacebook />, name: 'Facebook', url: 'https://facebook.com', color: '#1877f2' },
    { icon: <FaInstagram />, name: 'Instagram', url: 'https://instagram.com', color: '#e4405f' },
    { icon: <FaTwitter />, name: 'Twitter', url: 'https://twitter.com', color: '#1da1f2' },
    { icon: <FaYoutube />, name: 'YouTube', url: 'https://youtube.com', color: '#ff0000' }
  ];

  // Mobile Bottom Navigation
  const MobileBottomNav = () => (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 shadow-lg z-40" style={{ maxWidth: '500px', margin: '0 auto' }}>
      <div className="flex justify-around py-2">
        <button onClick={() => navigate('/')} className={`flex flex-col items-center py-1 px-5 rounded-full transition ${activeTab === 'home' ? 'text-[#1770b6]' : 'text-gray-400'}`}>
          <FaHome className="text-2xl" />
          <span className="text-xs mt-0.5 font-medium">Home</span>
        </button>
        <button onClick={() => navigate('/fish-food')} className={`flex flex-col items-center py-1 px-5 rounded-full transition ${activeTab === 'shop' ? 'text-[#1770b6]' : 'text-gray-400'}`}>
          <FaFish className="text-2xl" />
          <span className="text-xs mt-0.5 font-medium">Shop</span>
        </button>
        <button onClick={() => setActiveTab('contact')} className={`flex flex-col items-center py-1 px-5 rounded-full transition ${activeTab === 'contact' ? 'text-[#1770b6]' : 'text-gray-400'}`}>
          <FaEnvelope className="text-2xl" />
          <span className="text-xs mt-0.5 font-medium">Contact</span>
        </button>
        <button onClick={() => navigate('/profile')} className={`flex flex-col items-center py-1 px-5 rounded-full transition ${activeTab === 'profile' ? 'text-[#1770b6]' : 'text-gray-400'}`}>
          <FaUserCircle className="text-2xl" />
          <span className="text-xs mt-0.5 font-medium">Profile</span>
        </button>
      </div>
    </div>
  );

  // Mobile View (App-like Experience)
  const MobileView = () => (
    <div className="max-w-md mx-auto bg-gradient-to-b from-gray-50 to-gray-100 min-h-screen relative pb-24">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#1770b6] to-[#1770b6] pt-12 pb-8 px-5 rounded-b-3xl">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
            <FaFish className="text-2xl text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-white">Contact Us</h1>
            <p className="text-white/80 text-sm">We'd love to hear from you</p>
          </div>
        </div>
      </div>

      {/* Contact Info Cards */}
      <div className="px-4 -mt-6 mb-6">
        <div className="grid grid-cols-1 gap-3">
          {contactInfo.map((info, index) => (
            <div 
              key={index}
              onClick={info.onClick}
              className="bg-white rounded-2xl p-4 shadow-sm active:scale-98 transition-transform cursor-pointer"
            >
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center text-[#1770b6]">
                  {info.icon}
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold text-gray-800 text-sm">{info.title}</h3>
                  {info.details.map((detail, idx) => (
                    <p key={idx} className="text-gray-600 text-xs mt-0.5">{detail}</p>
                  ))}
                </div>
                <div className="text-[#1770b6] text-sm font-medium">{info.action} →</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Business Hours */}
      <div className="px-4 mb-6">
        <div className="bg-white rounded-2xl p-4 shadow-sm">
          <div className="flex items-center gap-2 mb-4">
            <FaClock className="text-[#1770b6] text-lg" />
            <h3 className="font-semibold text-gray-800">Business Hours</h3>
          </div>
          <div className="space-y-2">
            {businessHours.map((item, index) => (
              <div key={index} className="flex justify-between items-center text-sm">
                <span className="text-gray-600">{item.day}</span>
                <span className={`font-medium ${item.hours === 'Closed' ? 'text-red-500' : 'text-gray-800'}`}>
                  {item.hours}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Contact Form */}
      <div className="px-4 mb-6">
        <div className="bg-white rounded-2xl p-5 shadow-sm">
          <h3 className="font-semibold text-gray-800 text-lg mb-4 flex items-center gap-2">
            <FaComment className="text-[#1770b6]" /> Send a Message
          </h3>
          
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className={`relative transition-all duration-200 ${activeField === 'name' ? 'transform scale-102' : ''}`}>
              <div className="flex items-center border border-gray-200 rounded-xl focus-within:border-[#1770b6] focus-within:ring-2 focus-within:ring-[#1770b6] transition-all">
                <FaUser className="text-gray-400 ml-3 text-sm" />
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleInputChange}
                  onFocus={() => setActiveField('name')}
                  onBlur={() => setActiveField(null)}
                  required
                  className="flex-1 px-3 py-3 outline-none bg-transparent text-gray-800 placeholder:text-gray-400 text-sm"
                />
              </div>
            </div>

            <div className={`relative transition-all duration-200 ${activeField === 'email' ? 'transform scale-102' : ''}`}>
              <div className="flex items-center border border-gray-200 rounded-xl focus-within:border-[#1770b6] focus-within:ring-2 focus-within:ring-[#1770b6] transition-all">
                <FaEnvelope className="text-gray-400 ml-3 text-sm" />
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleInputChange}
                  onFocus={() => setActiveField('email')}
                  onBlur={() => setActiveField(null)}
                  required
                  className="flex-1 px-3 py-3 outline-none bg-transparent text-gray-800 placeholder:text-gray-400 text-sm"
                />
              </div>
            </div>

            <div className={`relative transition-all duration-200 ${activeField === 'phone' ? 'transform scale-102' : ''}`}>
              <div className="flex items-center border border-gray-200 rounded-xl focus-within:border-[#1770b6] focus-within:ring-2 focus-within:ring-[#1770b6] transition-all">
                <FaPhone className="text-gray-400 ml-3 text-sm" />
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleInputChange}
                  onFocus={() => setActiveField('phone')}
                  onBlur={() => setActiveField(null)}
                  className="flex-1 px-3 py-3 outline-none bg-transparent text-gray-800 placeholder:text-gray-400 text-sm"
                />
              </div>
            </div>

            <div className={`relative transition-all duration-200 ${activeField === 'subject' ? 'transform scale-102' : ''}`}>
              <div className="flex items-center border border-gray-200 rounded-xl focus-within:border-[#1770b6] focus-within:ring-2 focus-within:ring-[#1770b6] transition-all">
                <FaEnvelope className="text-gray-400 ml-3 text-sm" />
                <input
                  type="text"
                  name="subject"
                  placeholder="Subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  onFocus={() => setActiveField('subject')}
                  onBlur={() => setActiveField(null)}
                  required
                  className="flex-1 px-3 py-3 outline-none bg-transparent text-gray-800 placeholder:text-gray-400 text-sm"
                />
              </div>
            </div>

            <div className={`relative transition-all duration-200 ${activeField === 'message' ? 'transform scale-102' : ''}`}>
              <div className="border border-gray-200 rounded-xl focus-within:border-[#1770b6] focus-within:ring-2 focus-within:ring-[#1770b6] transition-all">
                <textarea
                  name="message"
                  placeholder="Your Message"
                  rows="4"
                  value={formData.message}
                  onChange={handleInputChange}
                  onFocus={() => setActiveField('message')}
                  onBlur={() => setActiveField(null)}
                  required
                  className="w-full px-4 py-3 outline-none bg-transparent text-gray-800 placeholder:text-gray-400 text-sm resize-none"
                />
              </div>
            </div>

            <button
              type="submit"
              className="w-full bg-gradient-to-r from-[#1770b6] to-[#1770b6] text-white py-3 rounded-xl font-semibold flex items-center justify-center gap-2 active:scale-98 transition-transform"
            >
              <FaPaperPlane className="text-sm" /> Send Message
            </button>
          </form>

          {/* Success Message */}
          {formStatus.submitted && formStatus.success && (
            <div className="mt-4 p-3 bg-green-50 rounded-xl flex items-center gap-2 animate-fade-in">
              <FaCheckCircle className="text-[#1770b6]" />
              <p className="text-[#1770b6] text-xs">{formStatus.message}</p>
            </div>
          )}
        </div>
      </div>

      {/* Social Media */}
      <div className="px-4 mb-6">
        <div className="bg-white rounded-2xl p-4 shadow-sm">
          <h3 className="font-semibold text-gray-800 text-sm mb-3 text-center">Follow Us</h3>
          <div className="flex justify-center gap-4">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full flex items-center justify-center transition-transform hover:scale-110 active:scale-95"
                style={{ backgroundColor: social.color }}
              >
                <span className="text-white text-lg">{social.icon}</span>
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Map Section */}
      <div className="px-4 mb-6">
        <div className="bg-white rounded-2xl overflow-hidden shadow-sm">
          <iframe
            title="Location Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d252360.9984917204!2d77.38849127370045!3d8.772839862832877!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b041047947b9dd3%3A0xd53bf49ca7d47d60!2sModern%20Rice%20Mill%20TNCSC%20THALAIYUTHU!5e0!3m2!1sen!2sin!4v1774362434204!5m2!1sen!2sin"
            width="100%"
            height="200"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="rounded-2xl"
          />
        </div>
      </div>

      {/* Bottom Navigation */}
      <MobileBottomNav />
    </div>
  );

  // Desktop View
  const DesktopView = () => (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-[#1770b6] to-[#1770b6] overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-6 py-16">
          <div className="text-center">
            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur rounded-full px-4 py-2 mb-4">
              <FaFish className="text-white" />
              <span className="text-sm text-white">Get in Touch</span>
            </div>
            <h1 className="text-5xl font-bold text-white mb-4">Contact Our Team</h1>
            <p className="text-white/90 text-lg max-w-2xl mx-auto">
              Have questions about our premium fish food? We're here to help!
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid lg:grid-cols-2 gap-8">
          {/* Left Column - Contact Info */}
          <div className="space-y-6">
            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2">
                <FaEnvelope className="text-[#1770b6]" /> Get in Touch
              </h2>
              <div className="space-y-4">
                {contactInfo.map((info, index) => (
                  <div 
                    key={index}
                    onClick={info.onClick}
                    className="flex items-start gap-4 p-4 rounded-xl hover:bg-gray-50 transition cursor-pointer group"
                  >
                    <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center text-[#1770b6] group-hover:scale-110 transition">
                      {info.icon}
                    </div>
                    <div className="flex-1">
                      <h3 className="font-semibold text-gray-800">{info.title}</h3>
                      {info.details.map((detail, idx) => (
                        <p key={idx} className="text-gray-600 text-sm mt-0.5">{detail}</p>
                      ))}
                      <span className="text-[#1770b6] text-sm font-medium mt-1 inline-block group-hover:underline">
                        {info.action} →
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Business Hours */}
            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <h3 className="font-semibold text-gray-800 text-lg mb-4 flex items-center gap-2">
                <FaClock className="text-[#1770b6]" /> Business Hours
              </h3>
              <div className="space-y-3">
                {businessHours.map((item, index) => (
                  <div key={index} className="flex justify-between items-center py-2 border-b border-gray-100 last:border-0">
                    <span className="text-gray-600">{item.day}</span>
                    <span className={`font-medium ${item.hours === 'Closed' ? 'text-red-500' : 'text-gray-800'}`}>
                      {item.hours}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Social Links */}
            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <h3 className="font-semibold text-gray-800 text-lg mb-4 text-center">Follow Us</h3>
              <div className="flex justify-center gap-4">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 rounded-full flex items-center justify-center transition-all hover:scale-110 hover:shadow-lg"
                    style={{ backgroundColor: social.color }}
                  >
                    <span className="text-white text-xl">{social.icon}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Right Column - Contact Form */}
          <div className="bg-white rounded-2xl p-6 shadow-sm">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2">
              <FaComment className="text-[#1770b6]" /> Send a Message
            </h2>
            
            <form onSubmit={handleSubmit} className="space-y-5">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Full Name *</label>
                  <div className="flex items-center border border-gray-200 rounded-lg focus-within:border-[#1770b6] focus-within:ring-2 focus-within:ring-[#1770b6] transition-all">
                    <FaUser className="text-gray-400 ml-3" />
                    <input
                      type="text"
                      name="name"
                      placeholder="Your Name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      className="flex-1 px-3 py-2.5 outline-none bg-transparent"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Email Address *</label>
                  <div className="flex items-center border border-gray-200 rounded-lg focus-within:border-[#1770b6] focus-within:ring-2 focus-within:ring-[#1770b6] transition-all">
                    <FaEnvelope className="text-gray-400 ml-3" />
                    <input
                      type="email"
                      name="email"
                      placeholder="your@email.com"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      className="flex-1 px-3 py-2.5 outline-none bg-transparent"
                    />
                  </div>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
                <div className="flex items-center border border-gray-200 rounded-lg focus-within:border-[#1770b6] focus-within:ring-2 focus-within:ring-[#1770b6] transition-all">
                  <FaPhone className="text-gray-400 ml-3" />
                  <input
                    type="tel"
                    name="phone"
                    placeholder="+91 80726 21187"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="flex-1 px-3 py-2.5 outline-none bg-transparent"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Subject *</label>
                <div className="flex items-center border border-gray-200 rounded-lg focus-within:border-[#1770b6] focus-within:ring-2 focus-within:ring-[#1770b6] transition-all">
                  <FaEnvelope className="text-gray-400 ml-3" />
                  <input
                    type="text"
                    name="subject"
                    placeholder="How can we help?"
                    value={formData.subject}
                    onChange={handleInputChange}
                    required
                    className="flex-1 px-3 py-2.5 outline-none bg-transparent"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Message *</label>
                <textarea
                  name="message"
                  rows="5"
                  placeholder="Tell us about your inquiry..."
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:border-[#1770b6] focus:ring-2 focus:ring-[#1770b6] outline-none transition-all resize-none"
                />
              </div>

              <button
                type="submit"
                className="w-full bg-gradient-to-r from-[#1770b6] to-[#1770b6] text-white py-3 rounded-lg font-semibold flex items-center justify-center gap-2 hover:from-[#1770b6] hover:to-[#1770b6] transition-all hover:shadow-lg"
              >
                <MdSend className="text-lg" /> Send Message
              </button>

              {formStatus.submitted && formStatus.success && (
                <div className="p-4 bg-blue-50 rounded-lg flex items-center gap-2 animate-fade-in">
                  <FaCheckCircle className="text-[#1770b6] text-lg" />
                  <p className="text-[#1770b6] text-sm">{formStatus.message}</p>
                </div>
              )}
            </form>
          </div>
        </div>

        {/* Map Section */}
        <div className="mt-8 bg-white rounded-2xl overflow-hidden shadow-sm">
          <iframe
            title="Location Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d252360.9984917204!2d77.38849127370045!3d8.772839862832877!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b041047947b9dd3%3A0xd53bf49ca7d47d60!2sModern%20Rice%20Mill%20TNCSC%20THALAIYUTHU!5e0!3m2!1sen!2sin!4v1774362434204!5m2!1sen!2sin"
            width="100%"
            height="350"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </div>
  );

  return isMobile ? <MobileView /> : <DesktopView />;
};

export default ContactPage;